import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Sort } from 'src/app/supporting/General';
import { ConfigurationManagementService } from 'src/service/configuration-management.service';
import { LanguageManagementService } from 'src/service/language-management.service';
import { FocusInputType, GeneralConfigType, InteractionType, KeyValues5, KeyValueSet, KeyValueSets, LocalService, NumericConfig, PageKey, RelationShipRole, Status, TriggeredEvent, QrLabelTemplateType, ActiveInactiveFor, KeyValues30, PrintHtml } from 'src/service/local.service';
import { ProductManagementService } from 'src/service/product-management.service';
import { QrlabelService } from 'src/service/qrlabel.service';

@Component({
  selector: 'app-qr-label-template-config',
  templateUrl: './qr-label-template-config.component.html',
  styleUrl: './qr-label-template-config.component.scss'
})
export class QrLabelTemplateConfigComponent {
  lstSectionConfigKeys: string[] = ["qr_label_gen"]; RelationShipRole = RelationShipRole;
  ctryCode: string = ''; businessId: string = ''; userId: string = ''; interactionType = 0;
  numericConfig: NumericConfig = { isDecimalAllowed: true } as NumericConfig;

  variables: KeyValues30[] = []; templateFor: KeyValueSet[] = []; templateId: string = '';
  item: KeyValues5; isOpenVariableConfig: boolean = false; isOpenLabelPreviewSettings: boolean = false; selectedVariableId: string = '';
  variableTypes: KeyValueSet[] = []; dynamicValuesType: KeyValueSet[] = []; fontOptions: KeyValueSets[] = []; customFields: KeyValueSet[] = [];
  isShowDeleted = false; maxBodyHeight = 0;

  htmlId: string = ''; elementIds: any;
  constructor(public localService: LocalService, private route: ActivatedRoute, private configurationManagementService: ConfigurationManagementService, private languageManagementService: LanguageManagementService, private qrlabelService: QrlabelService, private router: Router, private cdr: ChangeDetectorRef, private productManagementService: ProductManagementService) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      template_for: 'template_for_' + this.htmlId,
      title: 'title_' + this.htmlId,
      height: 'height_' + this.htmlId,
      width: 'width_' + this.htmlId,
    };
  }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.interactionType = routeParams.interactionType;
      this.businessId = routeParams.businessId;
      this.userId = routeParams.userId;
      this.templateId = routeParams.id;
      //this.configurationManagementService.ensurePageActions(PageKey.QrTemplateConfig, this.businessId);
      if (this.interactionType != InteractionType.User && (!this.businessId || this.businessId.length < 5)) {
        this.localService.redirectToSeller();
      } else {
        this.localService.saveUrl();
        this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType, routeParams.businessId);
        this.ctryCode = routeParams.ctryCode;
        this.onInitiate();
      }
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onInitiate() {
    if (!this.templateFor || this.templateFor.length == 0) {
      this.onSetCustomFields();
      const configTypes: GeneralConfigType[] = [GeneralConfigType.QrLabelTemplateType, GeneralConfigType.QrLabelVariableType, GeneralConfigType.QrLabelDynamicValue];
      this.configurationManagementService.getConfigurationsToDisplayMulti(configTypes, true, false).subscribe(result => {
        result.forEach(item => {
          switch (parseInt(item.key)) {
            case GeneralConfigType.QrLabelTemplateType: {
              this.templateFor = item.value;
            } break;
            case GeneralConfigType.QrLabelVariableType: {
              this.variableTypes = item.value;
            } break;
            case GeneralConfigType.QrLabelDynamicValue: {
              this.dynamicValuesType = item.value;
            } break;
          }
        });
      });

      this.qrlabelService.getFontOptions().subscribe(result => {
        result.forEach(res => {
          const languageId: string = this.localService.getLanguageId(res.key);
          res.key = languageId;
          res.s_value = this.localService.getEquivalentTitleById(languageId);
          res.value = Sort(res.value, true, 'value');
        });
        result = Sort(result, true, 's_value');

        this.fontOptions = result;

      });
    }
    this.onLoad();
  }

  onLoad() {
    if (this.localService.isUserHasBusinessRole(this.businessId, RelationShipRole.Admin)) {
      this.qrlabelService.getQrLabelTemplate(this.businessId, this.templateId).subscribe(result => {
        this.item = result;
        this.selectedTemplateFor = this.item.v1 && this.item.v1.length > 0 ? parseInt(this.item.v1) : 0;
        this.localService.onFocusNextInput(this.elementIds.title, FocusInputType.TextBox);
      });
      this.onLoadVariables();
    }
  }

  onSetCustomFields() {
    this.productManagementService.getCustomFields(this.businessId, true).subscribe(result => {
      this.customFields = result.map(function (dt) {
        return {
          key: dt.key,
          value: dt.v2
        } as KeyValueSet;
      });
    });
  }

  onLoadVariables() {
    this.qrlabelService.getQrLabelVariables(this.templateId, !this.isShowDeleted).subscribe(result => {
      this.variables = result;
    });
  }

  selectedTemplateFor: QrLabelTemplateType = QrLabelTemplateType.None;
  onAction(index: number, key: string = '') {
    switch (index) {
      case 1: {
        this.selectedVariableId = key;
        this.isOpenVariableConfig = true;
      } break;
      case 2: {
        this.onSave();
      } break;
      case 3: {
        this.onRemove(key);
      } break;
      case 4: {
        this.isOpenLabelPreviewSettings = true;
      } break;
    }
  }

  onSave() {
    this.qrlabelService.saveQrLabelTemplate(this.item).subscribe(result => {
      this.localService.showInformationByStatus(result.status);

      if (result.status == Status.Success) {
        if (!(this.templateId.length > 5)) {
          this.router.navigate(['/qr-template-config' + this.localService.basicParamsString, this.businessId, result.id]);
        }
      } else {
        this.localService.onFocusNextInput(this.elementIds.title, FocusInputType.TextBox);
      }
    });
  }

  onVariableConfigClose(result: any) {
    if (result && result.event == TriggeredEvent.Ok) {
      this.onLoadVariables();
    }
  }

  onRemove(key: string) {
    this.qrlabelService.activeInactiveStatus(ActiveInactiveFor.QrVariable, key).subscribe(result => {
      this.localService.showInformationByStatus(result.status);
      if (result.status == Status.Success)
        this.variables = this.variables.filter(x => x.key != key);
    });
  }

  printHtml: PrintHtml;
  onHtmlGenerated(html: PrintHtml) {
    this.isOpenLabelPreviewSettings = false;
    this.printHtml = html;
  }
}
